import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltIconDownloadOutline } from '@cae/cobalt-react/icons/outline/CobaltIconDownloadOutline';
import { useDownloadCreditMemo } from '@features/invoices/hooks/use-download-credit-memo/useDownloadCreditMemo';
import * as React from 'react';

import type { CreditMemoDownloadCellProps } from './CreditMemoDownloadCell.types';

import styles from './CreditMemoDownloadCell.module.css';
const CreditMemoDownloadCell = React.memo(
  ({
    creditMemoId,
    creditMemoNumber,
  }: Readonly<CreditMemoDownloadCellProps>): React.ReactElement => {
    const { handleDownload, isDownloading } = useDownloadCreditMemo({
      creditMemoId,
      creditMemoNumber,
    });

    return (
      <CobaltButton
        variant="ghost"
        pending={isDownloading}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          void handleDownload();
        }}
        aria-label={`Download credit memo ${creditMemoNumber}`}
        data-testid="credit-memo-download-button"
        className={styles.downloadButton}
      >
        <CobaltIconDownloadOutline size="small" aria-hidden="true" />
      </CobaltButton>
    );
  }
);

CreditMemoDownloadCell.displayName = 'CreditMemoDownloadCell';
export { CreditMemoDownloadCell };
